import * as React from "react";
import Component from "../../../../AbstractComponent";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

interface TableRowInterface {
  label?: string,
  value?: any
}

export class CoachSummaryTable extends Component {
  render() {
    return (
      <Table className="coach-summary-table" style={{ ...this.props?.style }}>
        <TableBody>
          {this.props.tableRows?.map((rowObj: TableRowInterface) => (
            <TableRow>
              <TableCell>{rowObj?.label || ""}</TableCell>
              <TableCell>{rowObj?.value || ""}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }
}